import { render, staticRenderFns } from "./NewsComponentList.vue?vue&type=template&id=72a957f8"
import script from "./NewsComponentList.vue?vue&type=script&lang=js"
export * from "./NewsComponentList.vue?vue&type=script&lang=js"
import style0 from "./NewsComponentList.vue?vue&type=style&index=0&id=72a957f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports